import { Fragment, useEffect, useState } from "react";
import Logo from "../../assets/img/hotel2sejour_logo.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { routeContants } from "../../utils/RouteConstants";
import Footer from "../../layout/Footer";
import { HtmlHelper } from "../../utils/HtmlHelper";
import { Button, Checkbox, Flex, Form, Input } from "antd";
import { setCrossAgencies, setHotelUserPairs, setAgencyLimitedHotelPaximumIds, setHotelUserPermissions, setLanguage, setRememberInfo, setToken, setUser, setUserHotels, toLoading, toUnLoading } from "../../store/SiteSlice";
import { AuthService } from "../../services/AuthService";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { useMutation } from "react-query";
import { mdlLoginRequest } from "../../models/service-models/auth/LoginRequest";
import { SFModal } from "../../components/elements/SFModal";
import ForgotPasswordModal from "../../components/auth/ForgotPasswordModal";
import PasswordResetModal from "../../components/auth/PasswordResetModal";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { mdlRemember } from "../../models/ui-models/Remember";
import { LanguageDropdown } from "../../components/common/LanguageDropdown";
import { enmDirection } from "../../models/enums/Direction";

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const storeRemember = useAppSelector(x => x.site.rememberMe);
  const navigate = useNavigate();
  const [form] = Form.useForm<mdlLoginRequest>();
  const [openForgotModal, setOpenForgotModal] = useState<boolean>(false);
  const [openResetModal, setOpenResetModal] = useState<boolean>(false);
  const [rememberStatus, setRememberStatus] = useState<boolean>(false);
  const isUnderConstruction = process.env.REACT_APP_UNDER_CONSTRUCTION === "true";

  useEffect(() => {
    HtmlHelper.removeBodyClass("has-sidebar");
    HtmlHelper.addBodyClass("pg-auth");
    if (storeRemember && storeRemember.password && storeRemember.username) {
      setRememberStatus(true);
      form.setFieldValue("userName", storeRemember.username);
      form.setFieldValue("password", storeRemember.password);
    }
  }, [storeRemember]);

  useEffect(() => {

  }, [rememberStatus])

  const { mutateAsync, isLoading, data } = useMutation(
    (data: mdlLoginRequest) => {
      data.webLogin = true;
      return AuthService.Login(data)
    },
    {
      onMutate(variables) {
        dispatch(toLoading());
      },
      onError: error => {
        console.log(error);
      },
      onSuccess(data, variables, context) {
        if (data.header && data.header.success && data.body && data.body.userInfo) {
          if (!data.body.userInfo.isFirstVisit) {
            if (rememberStatus) {
              var rememberObj: mdlRemember = {
                password: variables.password,
                username: variables.userName
              }
              dispatch(setRememberInfo(rememberObj));
            } else {
              dispatch(setRememberInfo(undefined));
            }
            data.body.userInfo.firstName = data.body.userInfo.firstName;
            data.body.userInfo.lastName = data.body.userInfo.lastName;
            data.body.userInfo.email = data.body.userInfo.email;
            dispatch(setUser(data.body.userInfo));
            dispatch(setLanguage(data.body.userInfo.currentLanguage));
            dispatch(setHotelUserPairs(data.body.userInfo.hotelUserPairs));
            dispatch(setAgencyLimitedHotelPaximumIds(data.body.userInfo.agencyLimitedHotelPaximumIds));
            if (data.body.userInfo.hotels && data.body.userInfo.hotels.length > 0) {
              dispatch(setUserHotels(data.body.userInfo.hotels));
            }
            dispatch(setToken(data.body.userInfo.token));
            dispatch(setCrossAgencies(data.body.userInfo.crossAgencies));
            dispatch(setHotelUserPermissions(data.body.userInfo.permissions));

            navigate(routeContants.DASHBOARD);
          } else {
            dispatch(toUnLoading());
            dispatch(setUser(data.body.userInfo));
            dispatch(setLanguage(data.body.userInfo.currentLanguage));
            if (data.body.userInfo.hotels && data.body.userInfo.hotels.length > 0) {
              dispatch(setUserHotels(data.body.userInfo.hotels));
            }
            dispatch(setToken(data.body.userInfo.token));
            dispatch(setCrossAgencies(data.body.userInfo.crossAgencies));
            dispatch(setHotelUserPermissions(data.body.userInfo.permissions));
            dispatch(setHotelUserPairs(data.body.userInfo.hotelUserPairs));
            dispatch(setAgencyLimitedHotelPaximumIds(data.body.userInfo.agencyLimitedHotelPaximumIds));
            setOpenResetModal(true);
          }
        } else {
          dispatch(toUnLoading());
          toast.error(ObjectHelper.getErrorMessage(data.header.messages));
        }
      },
    }
  );

  const handleForgotCallback = () => {
    setOpenForgotModal(false);
  }

  const onRememberMeChange = (e: CheckboxChangeEvent) => {
    setRememberStatus(e.target.checked);
  }

  return (
    <Fragment>
      <div className="nk-app-root">
        <div className="nk-main ">
          <div className="nk-wrap nk-wrap-nosidebar">
            <div className="nk-content ">
              {!isUnderConstruction ? <>
                <div className="nk-block nk-block-middle nk-auth-body  wide-xs">
                <div className="brand-logo pb-4 text-center">
                  <img className="logo-img logo-img-lg" src={Logo} alt="logo" />
                </div>
                <div className="card card-bordered">
                  <div className="card-inner card-inner-lg">
                    <div className="nk-block-head">
                      <div className="nk-block-head-content">
                        <div className="nk-block-des">
                          <p>{t("login.signInSub")}</p>
                        </div>
                      </div>
                    </div>
                    <Form
                      initialValues={{ userName: storeRemember?.username, password: storeRemember?.password }}
                      name="login-form"
                      layout="vertical"
                      onFinish={async (values) => await mutateAsync(values)}
                      autoComplete="off"
                    >
                      <Form.Item<mdlLoginRequest>
                        label={t("login.userName")}
                        name="userName"
                        rules={[{ required: true, message: t("common.required") }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item<mdlLoginRequest>
                        label={t("login.password")}
                        name="password"
                        rules={[{ required: true, message: t("common.required") }, { min: 8, message: t("login.notValidPassword") }]}
                      >
                        <Input.Password />
                      </Form.Item>

                      <Form.Item>
                        <Flex align="center" justify="space-between">
                          <LanguageDropdown showText={true} direction={enmDirection.DOWN} />
                          <Flex align="center" gap={8}>
                            <Button type="primary" htmlType="submit">{t("login.signIn")}</Button>
                            <Button type="link" onClick={() => setOpenForgotModal(!openForgotModal)}>{t("login.forgotPassword")}</Button>
                          </Flex>
                        </Flex>
                      </Form.Item>

                      <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                          <Checkbox checked={rememberStatus} onChange={onRememberMeChange}>{t("login.rememberMe")}</Checkbox>
                        </Flex>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
              </> : <>
              <div className="nk-block nk-block-middle nk-auth-body  wide-xs">
                <h1>Under Construction</h1>
              </div>              
              </>}              
              <Footer />
            </div>
          </div>
        </div>
      </div>
      <SFModal
        width={window.innerWidth * 30 / 100}
        open={openForgotModal}
        toggler={() => { setOpenForgotModal(!openForgotModal) }}
        body={<ForgotPasswordModal onClose={() => setOpenForgotModal(false)} callback={handleForgotCallback} />}
        title={t("auth.reset.forgotTitle")}
      />
      <SFModal
        width={window.innerWidth * 30 / 100}
        open={openResetModal}
        toggler={() => { setOpenResetModal(!openResetModal) }}
        body={<PasswordResetModal userName={data?.body?.userInfo.userName} onClose={() => setOpenResetModal(false)} callback={handleForgotCallback} />}
        title={t("auth.reset.resetTitle")}
      />
    </Fragment>
  );
};

export default Login;
